import {Grid, Typography} from "@mui/material";
import React, {useEffect, useRef} from "react";
import {useInvestAssistantContext} from "../ContextType";
import {Slider} from "../Slider";

export function Stage3() {
    const {yourName, yourMail, selectedPath} = useInvestAssistantContext();

    // Scroll the success headline into view once the slide-in transition has finished,
    // so the user actually sees the confirmation.
    const headlineRef = useRef<HTMLHeadingElement>(null);
    useEffect(() => {
        const t = setTimeout(() => {
            headlineRef.current?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }, 450);
        return () => clearTimeout(t);
    }, []);

    return (
        <Slider nr={3}>
            <Grid container justifyContent="center" direction="column" alignItems="center" rowGap={3}>
                <Grid item>
                    <Typography ref={headlineRef} variant="h3">
                        Vielen Dank {yourName}!
                    </Typography>
                </Grid>
                <Grid item>
                    {selectedPath === 'newsletter' && yourMail &&
                        <Typography sx={{textAlign: {xs: 'center', sm: 'left'}}}>
                            Wir haben deine Anfrage erhalten und dir zur Bestätigung eine Nachricht an {yourMail} geschickt.
                        </Typography>
                    }
                    {selectedPath === 'rueckruf' &&
                        <Typography sx={{textAlign: {xs: 'center', sm: 'left'}}}>
                            Wir haben deine Rückrufanfrage erhalten und melden uns schnellstmöglich telefonisch bei dir.
                        </Typography>
                    }
                    {selectedPath === 'normal' &&
                        <Typography sx={{textAlign: {xs: 'center', sm: 'left'}}}>
                            Wir haben deine Anfrage erhalten und melden uns schnellstmöglich bei dir.
                        </Typography>
                    }
                </Grid>
            </Grid>
        </Slider>
    );
}
